import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { type ICategory } from '../models/ICategory';
import { type IMerchant } from '../models/IMerchant';
import { baseUrl } from '../Consts';
import i18n from '../i18n';

export const fetchMerchants = createAsyncThunk(
	'merchants/fetchAll',
	async (lng: string = 'ru', thunkAPI) => {
		try {
			const response = await axios.get<IMerchant[]>(`${baseUrl}/merchants?lng=${lng}`);
			return response.data;
		} catch (e) {
			console.log(e);
			return thunkAPI.rejectWithValue(i18n.t('Не удалось загрузить список магазинов'));
		}
	}
);

export const fetchCategories = createAsyncThunk(
	'categories/fetchAll',
	async (lng: string = 'ru', thunkAPI) => {
		try {
			const response = await axios.get<ICategory[]>(`${baseUrl}/categories?lng=${lng}`);
			return response.data;
		} catch (e) {
			console.log(e);
			return thunkAPI.rejectWithValue(i18n.t('Не удалось загрузить список категорий'));
		}
	}
);

export const fetchCurrencies = createAsyncThunk(
	'currencies/fetchAll',
	async (_, thunkAPI) => {
		try {
			const response = await axios.get<string[]>(`${baseUrl}/currencies`);
			return response.data;
		} catch (e) {
			console.log(e);
			return thunkAPI.rejectWithValue(i18n.t('Не удалось загрузить список валют'));
		}
	}
);
